<template>
  <section class="section">
    <div class="section-head">
      <h2 class="section-title">Ferramentas reservadas para este projeto</h2>
    </div>
    <div v-if="reservations.length === 0" class="hint">Sem reservas.</div>
    <div v-else class="task-list">
      <div v-for="entry in reservations" :key="entry.id" class="task-item">
        <strong>{{ itemName(entry.itemId) }}</strong>
        <div class="hint">Tarefa: {{ entry.taskId }} | Quantidade: {{ entry.quantity }}</div>
        <div class="hint">Periodo: {{ entry.reserveStartDate }} ate {{ entry.reserveEndDate }}</div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

interface WarehouseReservation {
  id: string
  itemId: string
  taskId: string
  quantity: number
  reserveStartDate: string
  reserveEndDate: string
}

export default defineComponent({
  name: 'ProjectWarehouseSection',
  props: {
    reservations: { type: Array as () => WarehouseReservation[], default: () => [] },
    itemName: { type: Function as unknown as () => (itemId: string) => string, required: true }
  }
})
</script>

<style scoped lang="scss">
.task-list {
  display: grid;
  gap: 10px;
}

.task-item {
  border: 1px solid rgba(31, 30, 26, 0.14);
  border-radius: 10px;
  padding: 10px;
  background: #fff;
}
</style>
